export default "__VITE_ASSET__BenwPdPG__"